// @ts-nocheck

"use client"

import Image from "next/image"
import Link from "next/link"
import React from "react"
import "./styles.scss"

const PropertyCoverPhoto = ({ href, photo, title }) => {
    return (
        <section className="property-cover__wrapper">
            <Link href={href || "/"} className="property-cover__container">
                <Image
                    src={photo || "/images/beluxe/"}
                    alt={title || " "}
                    layout="fill"
                    objectFit="cover"
                    lang="pl"
                    loading="lazy"
                    quality={100}
                    className="hover:scale-105 duration-1000 ease-in-out"
                />
            </Link>
        </section>
    )
}

export default PropertyCoverPhoto